const messages = {
    es: {
        routes: {
            about: "Sobre nosotros",
            menu: "Carta",
            products: "Nuestros productos",
            gallery: "Galería",
            events: "Acontecimientos",
            privacy: "Política de privacidad",
            legal: "Aviso legal",
            contact: "Contacto",
        },
        reserve: "Reserva",
        address: "Dirección",
        schedule: "Horarios",
        mon: "Lun",
        tue: "Mar",
        sat: "Sáb",
        sun: "Dom",
        priceWithoutIva: "Precios sin IVA",
        contact: "Contacto",
        headerMessage: "Estamos cerrados por vacaciones del 7 de Agosto al 8 de Septiembre",
        wizard: {
            book_table: "Reserva mesa en O'Peregrino",
            address: "C/ Aragón, 150 - Esquina C/ Villarroel 08011 Barcelona (Barcelona) ",
            standard_table: "MESA STANDARD",
            vip_table: "MESA VIP",
            no_min: "Sin minimo",
            free_ticket: "Tiquet libre",
            standard_room: "Mesa en una de las salas",
            select: "Selecciona",
            vip_text_1: "Mesa en sala vip",
            vip_text_2: "(Suplemento del 15% sobre el importe final)",
            people: "N. de comensales",
            adults: "Adultos",
            childs: "Niños",
            date: "Fecha",
            hours: "Horas disponibles",
            meal: "Comida",
            dinner: "Cena",
            next: "Continuar",
            call_us_1: "Llámanos al ",
            call_us_2: "si tienes cualquier duda",
            close: "Cerrar",
            back: "Atrás",
            title_form: "Facilítanos tus datos de contacto",
            form: {
                name: "Nombre",
                email: "Email",
                phone: "Teléfono",
                observations: "Observaciones",
                name_required: "Nombre obligatorio",
                phone_required: "Teléfono obligatorio",
                phone_valid: "Teléfono debe ser valido",
                email_required: "Email obligatorio",
                email_valid: "Email debe ser valido",
                error: "Se ha producido un error en la reserva"
            },
            comfirm_button: "Confirmar Reserva",
            comfirm_title: "Gracias por realizar tu solicitud de reserva",
            comfirm_text: "En breves momentos nos pondremos en contacto contigo para confirmar la reserva.",
            warning_text: "Si no encuentra el email en la bandeja de entrada, recuerda mirar a promociones (Gmail) y/o spam. Gracias.",

            no_table: "No hay mesas disponibles para esa fecha",
            something_went_wrong: "Ha ocurrido un error. Inténtalo nuevamente.",
        }
    },
    en: {
        routes: {
            about: "About us",
            menu: "Menu",
            products: "Our products",
            gallery: "Gallery",
            events: "Events",
            privacy: "Privacy Policy",
            legal: "Legal Notice",
            contact: "Contact",
        },
        reserve: "Reserve",
        address: "Address",
        schedule: "Schedule",
        mon: "Mon",
        tue: "Tue",
        sat: "Sat",
        sun: "Sun",
        priceWithoutIva: "Prices without VAT",
        contact: "Contact",
        headerMessage: "We are closed for holidays from August 7 to September 8",
        wizard: {
            book_table: "Book a table at O'Peregrino",
            address: "C/ Aragón, 150 - Esquina C/ Villarroel 08011 Barcelona (Barcelona) ",
            standard_table: "STANDARD TABLE",
            vip_table: "VIP TABLE",
            no_min: "No minimum",
            free_ticket: "Free ticket",
            standard_room: "Table in one of the rooms",
            select: "Choose",
            vip_text_1: "Table in VIP room",
            vip_text_2: "(Additional 15% charge.)",
            people: "N. of dinner guests",
            adults: "Adults",
            childs: "Kids",
            date: "Date",
            hours: "Hours available",
            meal: "Meal",
            dinner: "Dinner",
            next: "Next",
            call_us_1: "Call us at",
            call_us_2: "if you have any questions",
            close: "Close",
            back: "Back",
            title_form: "We need your contact information",
            form: {
                name: "Name",
                email: "Email",
                phone: "Phone",
                observations: "Observations",
                name_required: "Name required",
                phone_required: "Phone required",
                phone_valid: "Phone must be valid",
                email_required: "Email required",
                observations_required: "Observations required",
                email_valid: "Email must be valid",
                error: "An error has ocurred saving the reservation"
            },
            comfirm_button: "Comfirm Reservation",
            comfirm_title: "Thank you for your booking request",
            comfirm_text: "We will contact you shortly to confirm your reservation.",
            warning_text: "If you can't find the email in your inbox, remember to look at promotions (Gmail) and/or spam. Thank you.",
            no_table: "There are no tables available for that date",
            something_went_wrong: "Something went wrong. Please try again.",
        }
    },
    ca: {
        routes: {
            about: "Sobre nosaltres",
            menu: "Carta",
            products: "Els nostres productes",
            gallery: "Galeria",
            events: "Esdeveniments",
            privacy: "Política de privacitat",
            legal: "Avís legal",
            contact: "Contacte",
        },
        reserve: "Reserva",
        address: "Direcció",
        schedule: "Horaris",
        mon: "Dl",
        mar: "Dm",
        sat: "Ds",
        sun: "Dg",
        priceWithoutIva: "Preus sense IVA",
        contact: "Contacte",
        headerMessage: "Estem tancats per vacances del 7 d'Agost al 8 de Setembre",
        wizard: {
            book_table: "Reserva taula a O'Peregrino",
            address: "C/ Aragón, 150 - Esquina C/ Villarroel 08011 Barcelona (Barcelona) ",
            standard_table: "MESA STANDARD",
            vip_table: "MESA VIP",
            no_min: "Sense minim",
            free_ticket: "Tiquet lliure",
            standard_room: "Taula a una de les sales",
            select: "Selecciona",
            vip_text_1: "Taula a sala vip",
            vip_text_2: "(Suplement del 15% sobre l'import final.)",
            people: "N. de comensals",
            adults: "Adults",
            childs: "Nens",
            date: "Data",
            hours: "Hores disponibles",
            meal: "Menjar",
            dinner: "Sopar",
            next: "Continuar",
            call_us_1: "Truca'ns al",
            call_us_2: "si tens qualsevol dubte",
            close: "Tancar",
            back: "Enrere",
            title_form: "Facilita'ns les teves dades de contacte",
            form: {
                name: "Nom",
                email: "Email",
                phone: "Telèfon",
                observations: "Observacions",
                name_required: "Nom obligatori",
                phone_required: "Telèfon obligatori",
                phone_valid: "Telèfon ha de ser vàlid",
                email_required: "Email obligatori",
                observations_required: "Observacions obligatori",
                email_valid: "Email ha de ser vàlid",
                error: "S'ha produït un error en la reserva"
            },
            comfirm_button: "Confirmar Reserva",
            comfirm_title: "Gràcies per realitzar la teva sol·licitud de reserva",
            comfirm_text: "En breu ens posarem en contacte amb tu per confirmar la reserva.",
            warning_text: "Si no troba l'email a la safata d'entrada, recorda mirar a promocions (Gmail) i/o spam. Gràcies.",
            no_table: "No hi ha taules disponibles per a aquesta data",
            something_went_wrong: "S'ha produït un error. Intenta-ho de nou.",
        }
    }
};

export default messages;
